import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgZorroAntdModule } from 'ng-zorro-antd'
import { RouterModule } from '@angular/router';

import { FullLoadingComponent } from './component/full-loading/full-loading.component'
import { GuionPipe } from './pipes/guion.pipe';
import { RoundPipe } from './pipes/round.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling'
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ButtonTableComponent } from './component/button-table/button-table.component';
import { ButtonComponent } from './component/button/button.component';
import { LoadingComponent } from './component/loading/loading.component'

const MODULES = [CommonModule, RouterModule, NgZorroAntdModule, ScrollingModule, DragDropModule]

const COMPONENTS = [FullLoadingComponent, ButtonTableComponent, ButtonComponent, LoadingComponent]
const PIPES = [GuionPipe, RoundPipe]

@NgModule({
  imports: [...MODULES],
  exports: [...MODULES, ...COMPONENTS, ...PIPES],
  declarations: [...COMPONENTS, ...PIPES, ButtonTableComponent, ButtonComponent, LoadingComponent],
})
export class SharedModule {}
